import App from '@/models/App'

export default class ShareFolder extends App {
    static get entity() {
        return 'ShareFolders'
    }
    static fields() {
        return {
            folderId: this.attr(''),
            userId: this.attr(''),
            userName: this.attr(''),
            userProfileImage: this.attr(''),
            companyName: this.attr(''),
        }
    }
    static getByFolderId(folderId) {
        return this.query().where('folderId', folderId).get()
    }
    static add(data) {
        this.insert({
            data: {
                folderId: data.folderId,
                userId: data.userId,
                userName: data.userName,
                userProfileImage: data.userProfileImage,
                companyName: data.companyName,
            },
        })
    }
    static apiConfig = {
        actions: {
            fetch(folderId) {
                return this.get(`/folders/${folderId}/shares`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.overallURL(),
                })
            },
            create(folderId, params) {
                return this.post(
                    `/folders/${folderId}/shares`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
            destroy(shareUserId, folderId) {
                return this.delete(
                    `/folders/${folderId}/shares/${shareUserId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
